import { Component, OnInit, ChangeDetectionStrategy, Input } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { ErrorMessage, ErrorMessageType } from '../../helper/error-message';

interface ErrorMessages {
  [key: string]: string;
}

@Component({
  selector: 'app-control-errors',
  templateUrl: './control-errors.component.html',
  styleUrls: ['./control-errors.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ControlErrorsComponent implements OnInit {
  @Input() control?: AbstractControl;
  @Input() errorMessages: ErrorMessages = {};
  @Input() error?: string;
  @Input() touched: boolean = false;

  constructor() {}

  ngOnInit(): void {}

  getErrors(): Array<string> {
    if (this.control?.errors) {
      return Object.keys(this.control.errors);
    }
    return [];
  }

  getErrorMessage(error: string): string {
    return this.errorMessages[error] || ErrorMessage[error as keyof ErrorMessageType] || '';
  }

  getServerErrorMessage = (error: string | number): string => {
    if (typeof this.control?.errors?.[error] === 'string') {
      return this.control?.errors[error] ?? '';
    }
    return '';
  };
}
